import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import * as Constants from "../../../data/StringConstants";
import FoldersTable from "../../../components/Table/FoldersTable";
import { FoldersApi } from '../../../api/folders/folders';

/**
 * This container is responsible for data fetching and rendering of corresponding sub-components
 * for the 'Recently Updated Folders' view which lists all promotions (folders) available to an
 * organization that have been updated in the last 7 days
 */
export default function RecentlyUpdatedFoldersContainer(props) {
	const folderState = { data: [], totalItemCount: 0, isLoading: true };
	const [resp, setData] = useState(folderState);
	const queryParams = { recentOnly: true };
	const shownFolderCount = 100;
	
	useEffect(() => {
		let isCancelled = false;

		FoldersApi
			.fetchAllActiveFoldersForAnOrg(queryParams)
			.then(resp => {
				const newState = {
					data: resp.data,
					totalItemCount: resp.data.length,
					isLoading: false
				};
				!isCancelled && setData(newState);
			})
			.catch(err => console.log(Constants.NO_FOLDERS_RESP_ERR, err));

		return () => (isCancelled = true);
	}, []);

	return resp.isLoading ? <LoadingSpinner /> :
		<FoldersTable
			data={resp.data}
			shownFolderCount={shownFolderCount}
			{...props}
		/>
}

RecentlyUpdatedFoldersContainer.propTypes = {
	httpClient: PropTypes.object,
};
